import { useTranslation } from 'next-i18next';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@/components/atoms/Button/Button';
import nameSpacesConfig from '@/config/config.nameSpaces.json';
import { FormValues } from '@/containers/ConfigurePage/components/FormConfig/formData';
import { pushEvent } from '@/lib/gtm/gtmEvents';
import {
  subscriptionAvailabilityState,
  SubscriptionAvailabilityState,
} from '@/types/AssetCategoryResult';

interface Props {
  availabilityState: SubscriptionAvailabilityState;
  className?: string;
  disabled?: boolean;
}

export const OrderBikeButton = ({
  availabilityState,
  className,
  disabled,
}: Props) => {
  const { watch } = useFormContext<FormValues>();

  const heavyUse = watch('heavyUse');

  const { t } = useTranslation([
    nameSpacesConfig.pages,
    nameSpacesConfig.common,
  ]);
  return (
    <Button
      className={className}
      type="submit"
      variant="contained"
      color="secondary"
      fullWidth
      data-test-id="configure-submit-button"
      disabled={heavyUse === 'yes' && disabled}
      onClick={() => pushEvent({ name: 'Order bike' })}
    >
      {/* TEMPORARILY SOLUTION FOR INTRO WEEKS - ADDED waitinglist to condition */}
      {(availabilityState === subscriptionAvailabilityState.subscribe ||
        availabilityState === subscriptionAvailabilityState.waitinglist) &&
        t('configure.costSummary.submit')}
    </Button>
  );
};
